import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux'
import { store } from './store';
import { SnackbarProvider } from 'notistack';
import { createTheme, ThemeProvider } from '@mui/material';
// import "@fontsource/poppins";

const root = ReactDOM.createRoot(document.getElementById('root'));
let theme = createTheme({
  typography: {
    fontFamily: "Poppins, Arial, sans-serif",
  },
  palette: {
    text: {
      primary: "#22201F",
      secondary: "#425e0ae8",
      link: '#90caf9'
    },
    background: {
      default: "#FAFBF8",
      paper: "#FAFBF8",
    },
    action: {
      active: "#4F4F4F",
    },
    primary: {
      main: '#425e0ae8',
    },
    secondary: {
      main: '#22201F',
    },
    link: {
      main: '#609ac8',
    },
    custom: {
      queued: '#4F4F4F',
      queuedBackground: '#f0f0f0',
      queuedBorder: '#bdbdbd',

      running: '#1976d2',          
      runningBackground: '#e3f2fd',  
      runningBorder: '#90caf9',    

      inProgress: '#1976d2',          
      inProgressBackground: '#e3f2fd',  
      inProgressBorder: '#90caf9',     

      completed: '#388e3c',          
      completedBackground: '#e8f5e9',
      completedBorder: '#a5d6a7',

      succeed: '#388e3c',          
      succeedBackground: '#e8f5e9',
      succeedBorder: '#a5d6a7',

      failed: '#d32f2f',
      failedBackground: '#fdecea',
      failedBorder: '#f5c6cb',

      stopped: '#FF9800',           
      stoppedBackground: '#fff4e5',
      stoppedBorder: '#ffcc80',

      skiped: '#FF9800',           
      skipedBackground: '#fff4e5',
      skipedBorder: '#ffcc80',
    }
  },
});
root.render(
  // <React.StrictMode>
  <SnackbarProvider maxSnack={3}>
    <BrowserRouter>
      <Provider store={store}>
        <ThemeProvider theme={theme}>
          <App />
        </ThemeProvider>
      </Provider>
    </BrowserRouter>
  </SnackbarProvider>
  // </React.StrictMode >
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
